import type { ClientOperatingContextSummary } from "@solomon-apps/shared";

export function shouldShowClientOperatingContextSelector(contexts: readonly ClientOperatingContextSummary[]): boolean {
    return contexts.length > 1;
}

export function clientOperatingContextStatusLabel(context: ClientOperatingContextSummary): string | null {
    switch (context.readOnlyReason) {
        case "IssuerCapabilitySuspended":
            return "Distributor suspended";
        case "IssuerClientSuspended":
            return "Relationship suspended";
        case "IssuerClientCancelled":
            return "Relationship canceled";
        case null:
        default:
            break;
    }

    if (context.status === "Pending") {
        return "Pending";
    }
    if (context.isSelfClient) {
        return "Self-client";
    }
    return null;
}
